/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Coming_SoonInputs */

const en_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront coming soon`)
};

const es_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda próximamente`)
};

const fr_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine bientôt disponible`)
};

const de_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront kommt bald`)
};

const ja_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロント準備中`)
};

const zh_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店铺即将上线`)
};

const ar_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة المتجر قريباً`)
};

const id_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase segera hadir`)
};

const it_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vetrina in arrivo`)
};

const ru_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина скоро откроется`)
};

const pt_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine em breve`)
};

const ko_storefront_coming_soon = /** @type {(inputs: Storefront_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 준비 중`)
};

/**
* | output |
* | --- |
* | "Storefront coming soon" |
*
* @param {Storefront_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_coming_soon = /** @type {((inputs?: Storefront_Coming_SoonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Coming_SoonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_coming_soon(inputs)
	if (locale === "es") return es_storefront_coming_soon(inputs)
	if (locale === "fr") return fr_storefront_coming_soon(inputs)
	if (locale === "de") return de_storefront_coming_soon(inputs)
	if (locale === "ja") return ja_storefront_coming_soon(inputs)
	if (locale === "zh") return zh_storefront_coming_soon(inputs)
	if (locale === "ar") return ar_storefront_coming_soon(inputs)
	if (locale === "id") return id_storefront_coming_soon(inputs)
	if (locale === "it") return it_storefront_coming_soon(inputs)
	if (locale === "ru") return ru_storefront_coming_soon(inputs)
	if (locale === "pt") return pt_storefront_coming_soon(inputs)
	return ko_storefront_coming_soon(inputs)
});